<div class="row">
    <div class="col-12">
        <h4 class="mb-0 font-header-1 mb-2">Monitor List</h4>
    </div>
</div>

<!--slect Agency message-->
<div *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId=='00000000-0000-0000-0000-000000000000' || this.global.globalAgencyId == '' ">
    <div class="row mt-4 ">
      <div class="col ">
        <div widget class="card border-0 box-shadow">
          <div class="card-body  widget-body pt-2">
            <div class="text-center text-danger">
              <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                details</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

<div class="row mb-2" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
    <div class="col ">
        <div widget class="card border-0 box-shadow">

            <div class="card-body  widget-body pb-0 pt-2 mb-4">
                <div class="row ">
                    <div class="col-6 ps-1">
                        <button type="button" class="btn blue-btn btn-sm" data-bs-toggle="modal"
                            data-bs-target="#Createmodal" (click)="CreateorUpdateList('create')">Add
                            List</button>
                    </div>
                    <!-- <div class="col-6">
                        <button type="button" class="btn btn-sm text-right" (click)="clearlist('refresh')">
                            <i class="fa fa-repeat"> Refresh </i>
                        </button>
                    </div> -->
                </div>
                <!--========================================= ejs-grid ===================================================-->
                <div class="row mb-2 mt-2" style="min-height: 500px;">
                    <div class="col ps-1">
                        <ejs-grid #gridList [dataSource]='GridList | async' [allowPaging]='true'
                            [pageSettings]='initialPage' [filterSettings]='filterSettings' [allowFiltering]='true'
                            [showColumnChooser]='true' [allowResizing]='true' [allowSorting]='true'
                            (dataStateChange)='dataChangeList($event)' (actionBegin)="onActionList($event)">
                            <e-columns>
                                <e-column minWidth=100 headerText="Actions" [showInColumnChooser]='false'>
                                    <ng-template #template let-data>
                                        <button class="btn btn-edit-table" data-bs-toggle="modal"
                                            data-bs-target="#Createmodal"
                                            (click)="CreateorUpdateList('update');getDetails(data)"><i
                                                class="fa fa-edit"></i></button>&nbsp;
                                        <button class="btn btn-delete-table" data-bs-toggle="modal"
                                            data-bs-target="#deleteListmodal" (click)="getDetails(data)"><i
                                                class="fa fa-trash" ></i></button>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="colorName" headerText="Color Code" type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>

                                <e-column minWidth=100 field="colorNotes" headerText="Notes" type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column width="50" [showInColumnChooser]='false'>
                                    <ng-template #headerTemplate let-data>
                                        <div>
                                            <span id='show' (click)='showLocationColumns()'><i class="fa fa-cog fa-lg"
                                                    aria-hidden="true">
                                                </i></span>
                                        </div>
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- For Create or Update Modal -->
<span id="openListModal" data-bs-toggle="modal" data-bs-target="#Createmodal"></span>
<div class="modal fade" id="Createmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel"><span *ngIf="ListType == 'CreatelistModal'">
                        Create
                        Monitor</span>
                    <span *ngIf="ListType == 'UpdatelistModal'">Update Monitor</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="ListForm">
                    <div class="row">
                        <div class="col-lg-5">
                            <label>Select Color Code<sup class="super-script">*</sup>
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <!-- <select  formControlName="colorcode" [(ngModel)]="saveListFields.colorcode" class="form-select">
                                <option value="Red"><i style="color: red;" class="fa fa-circle"></i></option>
                                <option value="Yellow"><i style="color: yellow;" class="fa fa-circle"></i></option>
                                <option value="Green"><i style="color: green;" class="fa fa-circle"></i></option>
                                <option value="Blue"><i style="color: blue;" class="fa fa-circle"></i></option>
                            </select> -->

                            <!-- <select  formControlName="colorcode" [(ngModel)]="saveListFields.colorcode" class="form-select">
                                <option value="Red" style="color: red;">Red</option>
                                <option value="Yellow"><i style="color: yellow;" class="fa fa-circle"></i></option>
                                <option value="Green"><i style="color: green;" class="fa fa-circle"></i></option>
                                <option value="Blue"><i style="color: blue;" class="fa fa-circle"></i></option>
                            </select> -->

                            <ng-select [items]="colors" bindLabel="label" formControlName="colorcode" [(ngModel)]="selectedColor" (change)="colorChanged($event)"
                                placeholder="Select color">
                                <ng-template ng-label-tmp let-item="item">
                                    <i class="fa fa-circle" [ngStyle]="{'color': item.value}"></i> {{ item.label }}
                                </ng-template>

                                <ng-template ng-option-tmp let-item="item">
                                    <i class="fa fa-circle" [ngStyle]="{'color': item.value}"></i> {{ item.label }}
                                </ng-template>
                            </ng-select>

                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col-lg-5">
                            <label>Enter Notes<sup class="super-script">*</sup>
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <!-- <input type="text" formControlName="notes" class="form-control"
                                [(ngModel)]="saveListFields.notes" /> -->

                                <textarea type="text" class="form-control"   formControlName="notes" 
                                [(ngModel)]="saveListFields.notes"></textarea>
                         
                        </div>
                    </div>

                </form>
            </div>
            <div class="modal-footer">
                <button class="btn  btn-sm" (click)="SaveOrUpdateList();" [disabled]="!ListForm.valid || isSaveorUpdateBoolean"><span
                        *ngIf="ListType == 'create'"> Save &
                        Close</span> <span *ngIf="ListType == 'update'">Update & Close</span> </button>
                <button type="button" class="btn  btn-sm" data-bs-dismiss="modal"
                    (click)="clearlist('cancel')">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- For Delete Modal -->
<span id="closeListModal" data-bs-target="#deleteListmodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="deleteListmodal" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Delete Record</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="clearlist('cancel')"
                    aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <label>Do you want to delete this record ?</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="DeleteList()">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
                    (click)="clearlist('cancel')">No</button>
            </div>
        </div>
    </div>
</div>

